import React from "react";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import SaveIcon from "@material-ui/icons/Save";
import {IconButton, Tooltip} from "@mui/material";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import Autocomplete from "@material-ui/lab/Autocomplete";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField
} from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import "./AssignGameToMachine.css"
import withShipment from "../../../withShipment";
import {clearStatus} from "../../../redux/actions/global";
import {
  editAssignMachine,
  listAssignMachine,
  listGame,
  listMachine, loadStartedSession, resetMachine,
} from "../../../redux/actions/settings";
import {userInfoSelector} from "../../../redux/selectors/auth";
import {statusSelector} from "../../../redux/selectors/global";
import {
  assignTemplatesSelector,
  gameSelector, loadStartedSessionSelector,
  machineSelector,
} from "../../../redux/selectors/settings";
import {SAVE} from "../../global/constants";
import {ASSIGN_MACHINE} from "../../reading/masterReading/constants";
import FeedbackBar from "../../feedbackBar/FeedbackBar";
import "../ManageMachine/ManageMachine.css"
import ActiveSessionLockBanner from "../../global/ActiveSessionLockBanner";


class AssignGameToMachine extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      assignTemplates: [],
      feedbackBarOpen: false,
      feedbackMessage: '',
      feedbackStatus: '',
      showDeleteDialog: false,
      showResetDialog: false,
      rowToReset: null,
      rowToDelete: null,
      assignRangeStart: '',
      assignRangeEnd: '',
      assignType: '',
      isSessionActive: false
    };
  }

  componentDidMount() {
    this.props.listGame(this.props.userInfo.selectedLocationId);
    this.props.listMachine(this.props.userInfo.selectedLocationId);
    this.props.listAssignMachine(this.props.userInfo.selectedLocationId);
    this.props.loadStartedSession({ locationId: this.props.userInfo.selectedLocationId, isAssignMachine: true});
    this.pushMenuItems();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.assignTemplates !== this.props.assignTemplates) {
      // Only sync from Redux when server data actually changed (different IDs),
      // not just a new array reference. Prevents overwriting locally generated templates.
      const prevIds = (prevProps.assignTemplates || []).map(t => t.assignMachineId).join(',');
      const nextIds = (this.props.assignTemplates || []).map(t => t.assignMachineId).join(',');
      if (prevIds !== nextIds && this.props.assignTemplates) {
        this.setState({ assignTemplates: this.props.assignTemplates });
      }
    }

    if (
        prevProps.loadSession !== this.props.loadSession &&
        this.props.loadSession &&
        Object.keys(this.props.loadSession).length > 0
    ) {
      this.setState({
        isSessionActive: this.props.loadSession.sessionStarted
      });
    }

    if (
      prevState.assignTemplates !== this.state.assignTemplates ||
      prevState.isSessionActive !== this.state.isSessionActive
    ) {
      this.pushMenuItems();
    }
  }

  pushMenuItems = () => {
    if (this.props.onMenuItemsChange) {
      this.props.onMenuItemsChange(this.getContextualMenuItems());
    }
  };

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState({
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',
    });
  };


  handleAssignTemplatesChange = (e, index) => {
    const { name, value } = e.target;
    this.setState((prevState) => {
      const updatedTemplates = [...prevState.assignTemplates];
      updatedTemplates[index] = {
        ...updatedTemplates[index],
        [name]: value,
      };

      // Check for duplicate machines
      const machineCounts = updatedTemplates.reduce((acc, item) => {
        if (item.machine) {
          acc[item.machine] = (acc[item.machine] || 0) + 1;
        }
        return acc;
      }, {});

      // Set a 'duplicateMachine' flag for rows
      updatedTemplates.forEach((item) => {
        item.duplicateMachine = machineCounts[item.machine] > 1;
      });

      return { assignTemplates: updatedTemplates };
    });
  };

  removeAssignTemplatesRow = (index) => {
    this.setState((prevState) => {
      const updatedTemplates = prevState.assignTemplates.filter(
        (_, curIndex) => curIndex !== index
      );
      return { assignTemplates: updatedTemplates };
    });
  };

  addAssignTemplatesRow = () => {
    this.setState((prevState) => {
      const updatedTemplates = [
        ...prevState.assignTemplates,
        {
          machine: '',
          type: '',
          game: '',
          prevIn: '0',
          prevOut: '0',
          curIn: '0',
          curOut: '0',
        },
      ];
      return { assignTemplates: updatedTemplates };
    });
  };

  getContextualMenuItems = () => [
    {
      title: SAVE,
      icon: <SaveIcon />,
      onClick: this.handleSave,
      disabled: this.isSaveDisabled(),
    },
  ];

  handleSave = () => {
    this.handleAssignGameToMachine(this.state.assignTemplates);
  };

  isSaveDisabled = () => {
    const { assignTemplates,isSessionActive } = this.state;

    if (isSessionActive) {
      return true;
    }

    // Allow saving an empty list (clears all assign machines).
    if (assignTemplates.length === 0) {
      return false;
    }

    const hasEmptyFields = assignTemplates.some(
      (assignMachine) =>
        !assignMachine.machine ||
        !assignMachine.type ||
        !assignMachine.prevIn ||
        !assignMachine.prevOut ||
        !assignMachine.curIn ||
        !assignMachine.curOut
    );

    const machineCount = {};
    const hasDuplicateMachine = assignTemplates.some(({ machine }) => {
      if (!machine) return false;
      machineCount[machine] = (machineCount[machine] || 0) + 1;
      return machineCount[machine] > 1;
    });

    return hasEmptyFields || hasDuplicateMachine;
  };

  handleAssignGameToMachine = (assignTemplates) => {
    const callback = (error, response) => {
      if (error) {
        this.openFeedbackBar('error', response);
      } else {
        this.openFeedbackBar('success', response);
      }
    };
    this.props.editAssignMachine(
      assignTemplates,
      this.props.userInfo.selectedLocationId,
      callback
    );
  };

  handleAssignRangeChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  generateAssignTemplates = () => {
    const {
      assignRangeStart,
      assignRangeEnd,
      assignType,
      assignTemplates,
    } = this.state;

    // Block generation when no machines exist in machines setup
    const savedMachines = this.props.machines || [];
    if (savedMachines.length === 0) {
      this.openFeedbackBar('error', 'No machines found. Add machines in machines setup first.');
      return;
    }

    const start = parseInt(assignRangeStart, 10);
    const end = parseInt(assignRangeEnd, 10);

    if (isNaN(start) || isNaN(end) || start > end) {
      this.openFeedbackBar('error', 'Invalid range');
      return;
    }

    if (!assignType) {
      this.openFeedbackBar('error', 'Type is required.');
      return;
    }

    // Only allow assigning machines that exist in machines setup
    const savedMachineNames = new Set(
      savedMachines.map((m) => (m.machine || '').toLowerCase())
    );

    const existingNames = new Set(
      assignTemplates.map((t) => (t.machine || '').toLowerCase())
    );
    const newTemplates = [];
    const skippedMachines = [];

    for (let i = start; i <= end; i++) {
      const machineName = `${i}`;
      if (!savedMachineNames.has(machineName.toLowerCase())) {
        skippedMachines.push(machineName);
        continue;
      }
      if (!existingNames.has(machineName.toLowerCase())) {
        newTemplates.push({
          machine: machineName,
          type: assignType,
          prevIn: '0',
          prevOut: '0',
          curIn: '0',
          curOut: '0',
        });
        existingNames.add(machineName.toLowerCase());
      }
    }

    if (newTemplates.length === 0 && skippedMachines.length > 0) {
      this.openFeedbackBar(
        'error',
        `Machines ${skippedMachines.join(', ')} do not exist in machines setup.`
      );
      return;
    }

    if (newTemplates.length === 0) {
      this.openFeedbackBar(
        'error',
        'All machines in the selected range already exist.'
      );
      return;
    }

    const updatedTemplates = [...assignTemplates, ...newTemplates];

    updatedTemplates.sort(
      (a, b) => parseInt(a.machine, 10) - parseInt(b.machine, 10)
    );

    this.setState({
      assignTemplates: updatedTemplates,
      assignRangeStart: '',
      assignRangeEnd: '',
      assignType: '',
    });
  };

  render() {
    return (
      <React.Fragment>
        {!this.props.embedded && (
          <TopToolbar
            pageName={ASSIGN_MACHINE}
            menuItems={this.getContextualMenuItems()}
          />
        )}

        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        {this.state.isSessionActive && (
          <ActiveSessionLockBanner sessionId={this.props.loadSession?.sessionId} />
        )}

        <Dialog
          open={this.state.showDeleteDialog}
          onClose={() => this.setState({ showDeleteDialog: false })}
        >
          <DialogTitle>{'Confirm Delete'}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this assign machine reading?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => this.setState({ showDeleteDialog: false })}
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={() => {
                this.removeAssignTemplatesRow(this.state.rowToDelete);
                this.setState({ showDeleteDialog: false, rowToDelete: null });
              }}
              color="primary"
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
            >
              {' '}
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.showResetDialog}
          onClose={() => this.setState({ showResetDialog: false })}
        >
          <DialogTitle>{'Confirm Reset'}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to reset this machine?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => this.setState({ showResetDialog: false })}
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={() => {
                const { assignTemplates, rowToReset } = this.state;

                const callback = (success, response) => {
                  if (success) {
                    this.openFeedbackBar('success', response);
                    const updatedTemplates = assignTemplates.map((template) => {
                      if (template.assignMachineId === rowToReset) {
                        return {
                          ...template,
                          prevIn: '0',
                          prevOut: '0',
                          curIn: '0',
                          curOut: '0',
                        };
                      }
                      return template;
                    });
                    this.setState({
                      assignTemplates: updatedTemplates,
                      showResetDialog: false,
                      rowToReset: null,
                    });
                  } else {
                    this.openFeedbackBar('error', response);
                  }
                };
                this.props.resetMachine(
                  { assignMachineId: this.state.rowToReset },
                  callback
                );
              }}
              color="primary"
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
            >
              {' '}
              Reset
            </Button>
          </DialogActions>
        </Dialog>

        <div className="manage-machine-range">
          <TextField
            variant="outlined"
            label="Start Range"
            InputLabelProps={{ shrink: true }}
            name="assignRangeStart"
            value={this.state.assignRangeStart || ''}
            onChange={this.handleAssignRangeChange}
            type="number"
            className="manage-machine-input"
          />
          <TextField
            variant="outlined"
            label="End Range"
            name="assignRangeEnd"
            InputLabelProps={{ shrink: true }}
            value={this.state.assignRangeEnd || ''}
            onChange={this.handleAssignRangeChange}
            type="number"
            className="manage-machine-input"
          />

          <Autocomplete
            className="manage-machine-input"
            options={this.props.games}
            getOptionLabel={(option) => option.type || ''}
            value={
              this.state.assignType ? { type: this.state.assignType } : null
            }
            onChange={(e, value) =>
              this.setState({
                assignType: value ? value.type : '',
              })
            }
            renderInput={(params) => (
              <TextField
                {...params}
                name="assignType"
                label="Type"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                required
              />
            )}
          />

          <Button
            className="manage-machine-button"
            variant="contained"
            color="primary"
            onClick={this.generateAssignTemplates}
            disabled={
              !this.state.assignRangeStart ||
              !this.state.assignRangeEnd ||
              !this.state.assignType
            }
          >
            Generate Assign Templates
          </Button>
        </div>

        <div className="manage-machine-list">
          <div className="transaction-form-section">
            {this.state.assignTemplates.map((machineAssign, index) => (
              <div className="row-manage-card" key={index}>


                <div className="manage-assign-machine-range">

                  <div className="remove-icon-wrapper">
                    <Tooltip title={'Delete machine'}>
                      <IconButton
                          disabled={this.state.isSessionActive}
                        onClick={() =>
                          this.setState({
                            showDeleteDialog: true,
                            rowToDelete: index,
                          })
                        }
                      >
                        <RemoveCircleIcon
                            fontSize="medium" color="error" />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title={'Reset machine'}>
                      <IconButton
                          disabled={this.state.isSessionActive}
                        onClick={() =>
                          this.setState({
                            showResetDialog: true,
                            rowToReset: machineAssign.assignMachineId,
                          })
                        }
                      >
                        <RestartAltIcon fontSize="medium" color="primary" />
                      </IconButton>
                    </Tooltip>
                  </div>

                  <Autocomplete
                    className="manage-machine-input"
                    options={this.props.machines}
                    getOptionLabel={(option) => option.machine}
                    value={
                      machineAssign.machine
                        ? { machine: machineAssign.machine }
                        : null
                    }
                    onChange={(e, value) =>
                      this.handleAssignTemplatesChange(
                        {
                          target: {
                            name: 'machine',
                            value: value ? value.machine : '',
                          },
                        },
                        index
                      )
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="machine"
                        label="Machine"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        required
                        disabled={this.state.isSessionActive}
                        error={
                          !machineAssign.machine ||
                          machineAssign.duplicateMachine
                        }
                        helperText={
                          machineAssign.duplicateMachine
                            ? 'Duplicate machine selected'
                            : ''
                        }
                      />
                    )}
                  />

                  <Autocomplete
                    className="manage-machine-input"
                    disabled={this.state.isSessionActive}
                    options={this.props.games}
                    getOptionLabel={(option) => option.type}
                    value={
                      machineAssign.type ? { type: machineAssign.type } : null
                    }
                    onChange={(e, value) =>
                      this.handleAssignTemplatesChange(
                        {
                          target: {
                            name: 'type',
                            value: value ? value.type : '',
                          },
                        },
                        index
                      )
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="type"
                        label="Type"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        required

                        error={!machineAssign.type}
                      />
                    )}
                  />

                  <TextField
                    className="manage-machine-input"
                    variant="outlined"
                    name="prevIn"
                    disabled={this.state.isSessionActive}
                    label="Prev In"
                    InputLabelProps={{ shrink: true }}
                    value={machineAssign.prevIn}
                    onChange={(e) =>
                      this.handleAssignTemplatesChange(
                        {
                          target: {
                            name: e.target.name,
                            value: e.target.value,
                          },
                        },
                        index
                      )
                    }
                    required
                    error={!machineAssign.prevIn}
                    type="number"
                    inputProps={{ min: '0', step: '1' }}
                  />

                  <TextField
                    className="manage-machine-input"
                    variant="outlined"
                    name="prevOut"
                    label="Prev Out"
                    InputLabelProps={{ shrink: true }}
                    value={machineAssign.prevOut}
                    onChange={(e) =>
                      this.handleAssignTemplatesChange(
                        {
                          target: {
                            name: e.target.name,
                            value: e.target.value,
                          },
                        },
                        index
                      )
                    }
                    disabled={this.state.isSessionActive}
                    required
                    error={!machineAssign.prevOut}
                    type="number"
                    inputProps={{ min: '0', step: '1' }}
                  />

                  <TextField
                    className="manage-machine-input"
                    variant="outlined"
                    name="curIn"
                    label="Cur In"
                    InputLabelProps={{ shrink: true }}
                    disabled={this.state.isSessionActive}
                    value={machineAssign.curIn}
                    onChange={(e) =>
                      this.handleAssignTemplatesChange(
                        {
                          target: {
                            name: e.target.name,
                            value: e.target.value,
                          },
                        },
                        index
                      )
                    }
                    required
                    error={!machineAssign.curIn}
                    type="number"
                    inputProps={{ min: '0', step: '1' }}
                  />

                  <TextField
                    className="manage-machine-input"
                    variant="outlined"
                    name="curOut"
                    label="Cur Out"
                    disabled={this.state.isSessionActive}
                    InputLabelProps={{ shrink: true }}
                    value={machineAssign.curOut}
                    onChange={(e) =>
                      this.handleAssignTemplatesChange(
                        {
                          target: {
                            name: e.target.name,
                            value: e.target.value,
                          },
                        },
                        index
                      )
                    }
                    required
                    error={!machineAssign.curOut}
                    type="number"
                    inputProps={{ min: '0', step: '1' }}
                  />
                </div>
              </div>
            ))}
            <div
              style={{
                marginTop: '30px',
                marginLeft: '16px',
                marginBottom: '30px',
              }}
            >
              <Tooltip title={'Add new machine for reading'}>
                <IconButton disabled={this.state.isSessionActive} onClick={this.addAssignTemplatesRow}>
                  <AddCircleIcon fontSize="medium" color="secondary" />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: userInfoSelector(state),
  status: statusSelector(state),
  games: gameSelector(state),
  machines: machineSelector(state),
  assignTemplates: assignTemplatesSelector(state),
  loadSession:loadStartedSessionSelector(state),
});


const actionCreators = {
  clearStatus,
  listGame,
  listMachine,
  editAssignMachine,
  resetMachine,
  listAssignMachine,
  loadStartedSession
}

export default withShipment({
  actionCreators,
  mapStateToProps
}, AssignGameToMachine);